import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import PartnerOfferDetailDialog from '@/views/config/partner-refer/dialog/offer-detail.vue';
import trackingMixin from '@/views/config/partner-refer/tracking/mx';

const listenerPartnerReferEventUtils = {
  hook: false,
  update(v) {
    this.hook = v;
  },
};

export default {
  mixins: [trackingMixin],
  created() {
    this.partnerOfferDetailDialog = new ServiceConfirm(PartnerOfferDetailDialog);
  },
  methods: {
    showOfferDetail() {
      this.partnerOfferDetailDialog.confirm();
      this.$tracking.buyInteraction(
        this.mx_trackingPartnerName,
        this.mx_trackingPartnerOfferDetailReason,
      );
    },
    licenseEvent(event) {
      const classList = [...event?.target?.classList ?? []];

      // open offer detail modal
      if (classList.includes('opc-partner-open-offer-detail')) {
        event?.preventDefault();
        this.showOfferDetail();
      }
    },
    handleClick(event) {
      this.licenseEvent(event);
    },
    handleKeydown(event) {
      const keyCode = event?.keyCode;
      if ([13, 32].includes(keyCode)) { // enter or space keydown
        this.licenseEvent(event);
      }
    },
  },
  mounted() {
    if (!listenerPartnerReferEventUtils.hook) {
      document.addEventListener('click', this.handleClick);
      document.addEventListener('keydown', this.handleKeydown);
      listenerPartnerReferEventUtils.update(true);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClick);
    document.removeEventListener('keydown', this.handleKeydown);
    if (listenerPartnerReferEventUtils.hook) {
      listenerPartnerReferEventUtils.update(false);
    }
  },
};
